module.exports = __webpack_public_path__ + "slider-04.jpg?febace62be38ad305c48515cb70052f0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-04.jpg
// module id = 268
// module chunks = 0